module.exports = __webpack_public_path__ + "static/layer1.8042ed22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layer1.png
// module id = 604
// module chunks = 35783957827783